import React, { useState, useEffect } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/VerifyRegisterOtp/Index";
import { validateAll } from "indicative/validator";
import ToastAlert from "../common/ToastAlert";
import ApiCall from "../common/ApiCall";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setEmailVerified, setLoading, setLogin } from "../redux/user/user.action";
import moment from 'moment';
import { setBookunWebhook, setFareharborWebhook } from "../redux/global/global.action";

export default function VerifyRegisterOtp() {

    const [state, setState] = useState({
        otp: "",
        error: [],
    })
    const { otp } = state;
    const [canResend, setCanResend] = useState(true);
    const [timer, setTimer] = useState(0);
    const RESEND_TIMEOUT = 10 * 60 * 1000;  // 10 minutes

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);



    const changeValue = (e) => {
        let value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        setState({
            ...state,
            [e.target.name]: numericValue
        })

        if (numericValue.length === 6) {
            verify(e, numericValue.trim());
        }
    }

    const handlePaste = (e) => {
        const pastedValue = e.clipboardData.getData('text');
        setState({
            ...state,
            otp: pastedValue
        })
        verify(e, pastedValue.trim())


    };

    const handlePasteButtonClick = async (e) => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            setState({
                ...state,
                otp: clipboardText
            })

            verify(e, clipboardText.trim())

        } catch (err) {

        }
    };

    const verify = (e, code = null) => {

        e?.preventDefault();

        const rules = {
            otp: 'required|min:6|max:6',

        }
        let stateData = {
            otp: String(code) ?? String(otp)
        }
        // console.log(stateData);


        const message = {
            'otp.required': 'code is Required.',
            'otp.min': 'The code must be exactly 6 characters long',
            'otp.max': 'The code must be exactly 6 characters long',
        }

        validateAll(stateData, rules, message).then(async () => {
            dispatch(setLoading(true))
            const formaerrror = {};
            // setState({
            //     ...state,
            //     error: formaerrror,
            //     otp: code ?? otp
            // })

            let data = {}
            data.otp = stateData.otp
            data.user_id = user?.userDetails?.id


            const verifyOtp = await ApiCall('post', 'verify-register', data)

            if (verifyOtp) {
                dispatch(setLoading(false))
                if (verifyOtp.data.success) {
                    localStorage.removeItem('lastSentTime');
                    dispatch(setEmailVerified(true))
                    let dispatchData = {}
                    dispatchData.userDetails = verifyOtp.data.user
                    dispatchData.token = verifyOtp.data.access_token
                    dispatchData.tempEmail = verifyOtp.data.user.email
                    dispatchData.supplierDetails = verifyOtp.data.supplier
                    dispatch(setLogin(dispatchData))
                    dispatch(setBookunWebhook(verifyOtp.data?.isBokunWebhookSetup));
                    dispatch(setFareharborWebhook(verifyOtp.data?.isFareharborWebhookSetup));


                    ToastAlert({ msg: verifyOtp.data?.message, msgType: 'success' });
                    navigate('/dashboard')

                } else {

                    if (verifyOtp.data?.errors && Object.keys(verifyOtp.data.errors).length) {

                        setState({
                            ...state,
                            error: verifyOtp.data.errors,
                        })

                    } else {
                        const formaerrror = {};
                        formaerrror.otp = verifyOtp.data.message
                        setState({
                            ...state,
                            error: formaerrror,
                            otp: stateData.otp
                        })
                        // ToastAlert({ msg: verifyOtp.data.message, msgType: 'error' });
                    }
                }
            } else {
                dispatch(setLoading(false))
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }



        }).catch(errors => {
            dispatch(setLoading(false))
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setState({
                ...state,
                error: formaerrror,
                otp: stateData.otp
            })

        });

    }

    const resendOtp = async () => {
        let data = {}
        data.user_id = user?.userDetails?.id


        dispatch(setLoading(true))
        const resendVerificationOtp = await ApiCall('post', 'resend-register-otp', data)
        if (resendVerificationOtp) {
            dispatch(setLoading(false))
            if (resendVerificationOtp.data.success) {
                localStorage.setItem('lastSentTime', Date.now());
                setCanResend(false);
                setTimer(RESEND_TIMEOUT / 1000);
                ToastAlert({ msg: resendVerificationOtp.data.message, msgType: 'success' });

            } else {

                // ToastAlert({ msg: resendVerificationOtp.data.message, msgType: 'error' });
                const formaerrror = {};
                formaerrror.otp = resendVerificationOtp.data.message
                setState({
                    ...state,
                    error: formaerrror,
                })
            }
        } else {
            dispatch(setLoading(false))
            ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
        }

    }

    useEffect(() => {
        const lastSentTime = localStorage.getItem('lastSentTime');

        if (lastSentTime) {
            const timePassed = Date.now() - lastSentTime;

            if (timePassed < RESEND_TIMEOUT) {
                setCanResend(false);
                setTimer(Math.ceil((RESEND_TIMEOUT - timePassed) / 1000)); // Set timer in seconds
            } else {
                localStorage.removeItem('lastSentTime'); // Clear if timeout passed
            }
        }
    }, []);

    useEffect(() => {
        let countdown;
        if (!canResend && timer > 0) {
            countdown = setInterval(() => {
                setTimer(prev => {
                    if (prev <= 1) {
                        setCanResend(true);
                        clearInterval(countdown);
                        localStorage.removeItem('lastSentTime'); // Clear timestamp when cooldown ends
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [canResend, timer]);

    const formatTime = (seconds) => {
        return moment.utc(seconds * 1000).format("m:ss"); // Convert seconds to milliseconds for Moment.js
    };

    
    return (
        <>
            <PageTitle title={'Verify otp'} />
            <Index
                verify={verify}
                state={state}
                changeValue={changeValue}
                handlePaste={handlePaste}
                handlePasteButtonClick={handlePasteButtonClick}
                canResend={canResend}
                timer={timer}
                resendOtp={resendOtp}
                formatTime={formatTime}
            />
        </>
    )

}